"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doDevelopmentLogin = void 0;
var _AuthorizationCodeTokenClient = require("../AuthorizationCodeTokenClient");
var _OidcClient = require("../OidcClient");
var _OidcUrlHelper = require("../OidcUrlHelper");
var _constants = require("../constants");
var _storage = require("../storage");
/**
 * Extracts token from current URL.
 * If token is not present in URL and app is without token then this will redirect to identity.
 * Identity on successful login redirects back to app with token in URL.
 */
const doDevelopmentLogin = async ({
  identityUrl,
  tenant
}) => {
  const searchParams = new URLSearchParams(window.location.hash.split('?')[1] ?? window.location.search);
  if (searchParams.has(_OidcUrlHelper.OidcUrlHelper.AUTH_CODE)) {
    const oidcUrlHelper = new _OidcUrlHelper.OidcUrlHelper();
    const tokenClient = new _AuthorizationCodeTokenClient.AuthorizationCodeTokenClient({
      clientId: _constants.IDENTITY_CLIENT_ID,
      identityUrl
    });
    oidcUrlHelper.storeAuthCodeFromParams(searchParams);
    await tokenClient.initializeTokenFromAuthorizationCode();
    oidcUrlHelper.handleRedirectAfterLogin();
  }
  const oidcTokenStorage = new _storage.OidcTokenStorage();
  const token = oidcTokenStorage.getAccessToken();
  if (!token) {
    const oidcClient = new _OidcClient.OidcClient({
      callbackUrl: '#/',
      redirectUrl: window.location.href
    }, {
      clientId: _constants.IDENTITY_CLIENT_ID,
      identityUrl,
      acrValues: `tenant:${tenant}`,
      scope: 'all'
    });
    oidcClient.doLogin();
  }
};
exports.doDevelopmentLogin = doDevelopmentLogin;
//# sourceMappingURL=doDevelopmentLogin.js.map